module.exports = __webpack_public_path__ + "media/fonts/avenir/Avenir-Medium-5da91e2be3c00226118fae1beb85fa0c.eot";